// extracted by mini-css-extract-plugin
export var attachment = "_nm-a";
export var emailContainer = "_nm-4";
export var emailContentPaddedContainer = "_nm-b";
export var emailHeader = "_nm-6";
export var emailIframe = "_nm-3";
export var emailInfoIcon = "_nm-9";
export var emailShortenedSummary = "_nm-e";
export var infoDropdown = "_nm-0";
export var infoRowBoundedContent = "_nm-d";
export var internal = "_nm-5";
export var merchant = "_nm-8";
export var messageInputContainer = "_nm-h";
export var normal = "_nm-7";
export var replyCard = "_nm-f";
export var subtleButton = "_nm-1";
export var subtleButtonIconContainer = "_nm-2";
export var toggleViewRepliesButton = "_nm-c";
export var wrappingText = "_nm-g";